module.exports = __webpack_public_path__ + "static/img/order-mobile-3.b31988a6.png";